import { BLOCKED_MODELS, ModelProviderIdentifier } from '@/consts/model-import.consts';
import { AiModelInfo, ModelService } from '@/designer/designer';
import { AiModelData, Model } from '@/types/nodes/model';
import type { BaseNodeData } from '@/types/node';

const SUPPORTED_MODEL_PROVIDER_SOURCES = [
  ModelProviderIdentifier.Civitai,
  ModelProviderIdentifier.FalDomain,
  ModelProviderIdentifier.FalPrefix,
  ModelProviderIdentifier.Replicate,
] as const;

/**
 * Checks if a given identifier is a valid model import identifier
 * @param identifier - The identifier to check
 */
export const isValidModelImportIdentifier = (identifier: string): boolean => {
  // Check if source is blocked
  for (const blockedModel of BLOCKED_MODELS) {
    if (identifier.includes(blockedModel)) {
      return false;
    }
  }

  // Check if URL matches supported model services
  return SUPPORTED_MODEL_PROVIDER_SOURCES.some((service) => identifier.includes(service));
};

// TODO: remove after wildcard on new architecture
export const isImportedFromProviderOld = (model: Model, service: ModelService) => model.service === service;

export const isImportedFromProvider = (model: AiModelInfo, service: ModelService) =>
  (model.type === 'imported' || model.type === 'user_defined') && model.service === service;

export const getImportedModelNodeInfo = (data: BaseNodeData) => {
  const { kind } = data as AiModelData;
  const importedModel = kind?.type === 'wildcard' && kind.model.type === 'imported' ? kind.model : undefined;
  return {
    isImportedModel: !!importedModel,
    modelId: importedModel?.name,
    modelService: importedModel?.service,
  };
};

export const isUserImportedModelNode = (data: BaseNodeData): boolean => {
  const nodeData = data as AiModelData & { isWildCard?: boolean };
  const kindModelType = nodeData.kind?.type === 'wildcard' ? nodeData.kind.model?.type : undefined;
  return (
    kindModelType === 'imported' ||
    kindModelType === 'user_defined' ||
    nodeData.isWildCard === true ||
    Boolean(nodeData.model?.originalImportSource)
  );
};
